import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import useFive9IntegrationEnabled from 'src/hooks/five9/useFive9IntegrationEnabled';
import Five9CrmAdapter from './Five9CrmAdapter';
import Five9LogPanel from './Five9LogPanel';

const ERROR_PAGE_PATTERN = /^\/(401|403|404|500)\/?$/;
const CUSTOMER_MONITOR_ROUTE = 'customer-dispatch-monitor';

// Must render under <Router>: useLocation() keeps `hidden` in sync with
// client-side navigation (see docs/five9-integration.md §3).
export function Five9Shell({ user }) {
  const five9Enabled = useFive9IntegrationEnabled();
  const location = useLocation();
  if (!five9Enabled) return null;
  const pathname = location.pathname || '';
  const twilio = new URLSearchParams(location.search || '').get('twilio');
  const hidden = !!twilio
    || pathname.includes(CUSTOMER_MONITOR_ROUTE)
    || ERROR_PAGE_PATTERN.test(pathname)
    || !user;
  return (
    <>
      <Five9CrmAdapter hidden={hidden} />
      <Five9LogPanel hidden={hidden} />
    </>
  );
}

Five9Shell.propTypes = {
  /** Authenticated account user; the panel is hidden until one exists. */
  user: PropTypes.shape({})
};

export default Five9CrmAdapter;
